import { FillInTheBlankInputType, FillInTheBlankQuestion } from '~/types/bootcamp'
import { normalizeLatexAnswer } from '~/in-app-keyboard/utils/normalizeLatexAnswer'

import { getRandomInt } from '~/bootcamp/Activities/Fractions/Fractions.utils'

import { FillInTheBlankActivityData } from './FillInTheBlank.type'

/**
 * choose question
 * @param questions all available multiple choice question
 * @param history previously selected question history
 * @returns fill in the blank  activity data
 */
export function generateFillInTheBlanksActivityData(
  questions: FillInTheBlankQuestion[],
  history: number[],
): FillInTheBlankActivityData {
  const questionIndex = getRandomInt(0, questions.length - 1, history)
  const question = questions[questionIndex]
  return { questionIndex, question }
}

function matchesAnswer(typed: string, accepted: string[], type: FillInTheBlankInputType): boolean {
  const acceptedParsed = accepted.map((answer) => parseAnswerByType(answer, type))
  return (
    acceptedParsed.includes(parseAnswerByType(typed, type)) ||
    acceptedParsed.includes(parseAnswerByType(normalizeLatexAnswer(typed), type))
  )
}

export function checkAnswer(question: FillInTheBlankQuestion, answers: string[]): boolean[] {
  if (question.areInputsDependent) {
    let isCorrect = false
    const maxInputAnswerLength = Math.max(...question.inputs.map((input) => input.answers.length))
    // eslint-disable-next-line fp/no-loops
    for (let i = 0; i < maxInputAnswerLength; i++) {
      let isCurrentOrderRight = true
      // eslint-disable-next-line fp/no-loops
      for (let j = 0; j < question.inputs.length; j++) {
        if (!matchesAnswer(answers[j], [question.inputs[j].answers[i]], question.inputs[j].inputType)) {
          isCurrentOrderRight = false
        }
      }
      if (isCurrentOrderRight) {
        isCorrect = true
        break
      }
    }
    return isCorrect ? answers.map(() => true) : []
  } else {
    const areInputsCorrect = new Array(question.inputs.length).fill(false)
    // eslint-disable-next-line fp/no-loops
    for (let i = 0; i < question.inputs.length; i++) {
      if (matchesAnswer(answers[i], question.inputs[i].answers, question.inputs[i].inputType)) {
        areInputsCorrect[i] = true
      }
    }
    return areInputsCorrect
  }
}

/**
 * parse answer by it's input type
 * @param answer answer to parse
 * @param type type of the answer
 * @returns parsed answer
 */
function parseAnswerByType(answer: string, type: FillInTheBlankInputType): string | number {
  let tempAnswer: string | number = answer.trim()
  if (type === FillInTheBlankInputType.INTEGER) {
    tempAnswer = parseInt(tempAnswer)
  } else if (type === FillInTheBlankInputType.FLOAT) {
    tempAnswer = tempAnswer.replaceAll(',', '.')
    tempAnswer = parseFloat(tempAnswer).toFixed(3)
  }
  return tempAnswer
}
